import { useState } from "react";
import { DataTable, DataTableExpandedRows, DataTableValueArray } from "primereact/datatable";
import { Column } from "primereact/column";
import { CustomSortIcon } from "../../../../../components/DatatableHelpers";
import {
	EssayDraftHistorySummary,
	EssayDraftHistoryTableProps,
	teacherFilteredColumns,
} from "../../../shared/progress/essayDraftHistory/TableUtil";
import { toOrdinal } from "../../../../../app/utils";

export default function EssayDraftHistoryTable({ data }: EssayDraftHistoryTableProps) {
	const [expandedRows, setExpandedRows] = useState<
		DataTableExpandedRows | DataTableValueArray | undefined
	>(undefined);

	const averageIncreaseTemplate = (item: EssayDraftHistorySummary) => {
		const isZero = item.averageIncrease === 0;
		const isPositive = item.averageIncrease > 0;
		return (
			<span className={`${isZero ? "" : isPositive ? "text-green-700" : "text-red-700"}`}>
				{isPositive ? `+${item.averageIncrease}` : item.averageIncrease}
			</span>
		);
	};

	const differenceFromClassAverageTemplate = (item: EssayDraftHistorySummary) => {
		if (item.differenceFromClassAverage === undefined) {
			return null;
		}

		const isZero = item.differenceFromClassAverage === 0;
		const isPositive = item.differenceFromClassAverage > 0;
		return (
			<span className={`${isZero ? "" : isPositive ? "text-green-700" : "text-red-700"}`}>
				{isPositive
					? `+${item.differenceFromClassAverage.toFixed(1)}`
					: item.differenceFromClassAverage.toFixed(1)}
			</span>
		);
	};

	const rowExpansionTemplate = (data: EssayDraftHistorySummary) => {
		const headerId = "nested-header";

		return (
			<div className="!-mx-4 !-my-3 min-w-full">
				<table className="tbl tbl-data">
					<thead>
						<tr>
							<th id={headerId} className="w-12"></th>
							<th id={headerId} className="w-1/6">
								Draft Number
							</th>
							<th id={headerId} className="w-5/6">
								Score
							</th>
						</tr>
					</thead>
					<tbody>
						{data.draftHistory.map((row, index) => {
							return (
								<tr key={row.draftId} className="hover:!bg-inherit">
									<td></td>
									<td>{toOrdinal(index + 1)} Draft</td>
									<td>{row.draftScore}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		);
	};

	const allowExpansion = (rowData: EssayDraftHistorySummary) => {
		return rowData.draftHistory!.length > 0;
	};

	return (
		<DataTable
			dataKey={"writerId"}
			value={data}
			loading={data == undefined}
			emptyMessage="No results found"
			stripedRows
			sortIcon={CustomSortIcon}
			className={`block tbl tbl-data tbl-datatable min-w-[40rem] cursor-default mt-4`}
			expandedRows={expandedRows}
			onRowToggle={(e) => setExpandedRows(e.data)}
			rowExpansionTemplate={rowExpansionTemplate}>
			<Column expander={allowExpansion} />
			{Object.entries(teacherFilteredColumns).map(([field, header], index) => (
				<Column
					key={index}
					field={field}
					header={header}
					body={
						field == "averageIncrease"
							? averageIncreaseTemplate
							: field == "differenceFromClassAverage"
								? differenceFromClassAverageTemplate
								: null
					}
					sortable
					headerClassName="!px-2"
					className="!px-2"
				/>
			))}
		</DataTable>
	);
}
